import React, { useState } from "react";
import DimensionamentoMap from "./DimensionamentoMap";
import { CiFilter } from "react-icons/ci";
import { MdClose } from "react-icons/md";
import {
  FormControl,
  FormLabel,
  FormControlLabel,
  RadioGroup,
  Radio,
  Checkbox,
  FormGroup,
  Switch, Typography, Box,
} from "@mui/material";

const MapModal = ({ open, onClose, data, dataLoading, state, parameterName }) => {
  const [regionType, setRegionType] = useState("municipio");
  const [useGradient, setUseGradient] = useState(true);
  const [statusFilter, setStatusFilter] = useState({
    insuficiente: true,
    suficiente: true,
    excedente: true,
  });

  if (!open) return null;

  const handleRegionChange = (event) => {
    setRegionType(event.target.value);
  };

  const handleStatusChange = (event) => {
    setStatusFilter({
      ...statusFilter,
      [event.target.name]: event.target.checked,
    });
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-md"
      onClick={onClose}
    >
      <div
        className="relative m-4 w-[95vw] xl:w-[90vw] max-w-7xl h-[95vh] xl:h-[90vh] rounded-3xl shadow-2xl bg-white/95 backdrop-blur-sm flex flex-col overflow-hidden border border-gray-200/50"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="relative w-full bg-gradient-to-r from-gray-50 to-gray-100 border-b border-gray-200/70">
          <div className="text-center py-6 px-8">
            <h2 className="text-3xl font-bold text-gray-700 bg-clip-text">
              {dataLoading ? "Carregando Mapa..." : `${parameterName} - ${state}`}
            </h2>
          </div>

          <button
            className="absolute top-4 right-4 w-10 h-10 flex items-center justify-center rounded-full bg-white/80 hover:bg-white shadow-lg hover:shadow-xl transition-all duration-200 text-gray-500 hover:text-gray-800 group"
            onClick={onClose}
          >
            <MdClose className="text-xl group-hover:scale-110 transition-transform duration-200"/>
          </button>
        </div>

        <div className="flex-1 flex flex-col xl:flex-row gap-8 p-8 overflow-auto">
          {!dataLoading && (
            <div className="w-full xl:w-1/3 xl:max-w-md">
              <Box
                className="bg-gradient-to-br from-gray-50 to-white border border-gray-200/70 rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300">
                <div className="flex items-center gap-3 mb-8">
                  <Typography
                    className="w-8 h-8 bg-gradient-to-br from-emerald-500 to-emerald-700 rounded-full flex items-center justify-center">
                   <CiFilter className='text-white w-5 h-5 stroke-1 '/>
                  </Typography>
                  <h3 className="text-xl font-bold text-gray-800">Filtros</h3>
                </div>

                <Box className="space-y-8">
                  <Box className="space-y-4">
                    <FormControl component="fieldset" fullWidth>
                      <FormLabel component="legend" className="text-gray-800 font-semibold text-base mb-4">
                        Região
                      </FormLabel>
                      <RadioGroup value={regionType} onChange={handleRegionChange} className="space-y-2">
                        <div
                          className="bg-white rounded-lg border border-gray-200 hover:border-green-300 transition-colors p-1">
                          <FormControlLabel
                            value="municipio"
                            control={<Radio color="success" size="small"/>}
                            label={<span className="text-gray-700 font-medium">Municípios</span>}
                            className="m-0 px-3 py-2 w-full"
                          />
                        </div>
                        <div
                          className="bg-white rounded-lg border border-gray-200 hover:border-green-300 transition-colors p-1">
                          <FormControlLabel
                            value="micro"
                            control={<Radio color="success" size="small"/>}
                            label={<span className="text-gray-700 font-medium">Micro-regiões</span>}
                            className="m-0 px-3 py-2 w-full"
                          />
                        </div>
                        <div
                          className="bg-white rounded-lg border border-gray-200 hover:border-green-300 transition-colors p-1">
                          <FormControlLabel
                            value="macro"
                            control={<Radio color="success" size="small"/>}
                            label={<span className="text-gray-700 font-medium">Macro-regiões</span>}
                            className="m-0 px-3 py-2 w-full"
                          />
                        </div>
                      </RadioGroup>
                    </FormControl>
                  </Box>

                  <div className="space-y-4">
                    <FormControl component="fieldset" fullWidth>
                      <FormLabel component="legend" className="text-gray-800 font-semibold text-base mb-4">
                        Suficiência
                      </FormLabel>
                      <FormGroup className="space-y-2">
                        <div
                          className="bg-white rounded-lg border border-gray-200 hover:border-green-300 transition-colors p-1">
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={statusFilter.insuficiente}
                                onChange={handleStatusChange}
                                name="insuficiente"
                                color="success"
                                size="small"
                              />
                            }
                            label={<span className="text-gray-700 font-medium">Insuficiente</span>}
                            className="m-0 px-3 py-2 w-full"
                          />
                        </div>
                        <div
                          className="bg-white rounded-lg border border-gray-200 hover:border-green-300 transition-colors p-1">
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={statusFilter.suficiente}
                                onChange={handleStatusChange}
                                name="suficiente"
                                color="success"
                                size="small"
                              />
                            }
                            label={<span className="text-gray-700 font-medium">Suficiente</span>}
                            className="m-0 px-3 py-2 w-full"
                          />
                        </div>
                        <div
                          className="bg-white rounded-lg border border-gray-200 hover:border-green-300 transition-colors p-1">
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={statusFilter.excedente}
                                onChange={handleStatusChange}
                                name="excedente"
                                color="success"
                                size="small"
                              />
                            }
                            label={<span className="text-gray-700 font-medium">Excedente</span>}
                            className="m-0 px-3 py-2 w-full"
                          />
                        </div>
                      </FormGroup>
                    </FormControl>
                  </div>
                </Box>
              </Box>
            </div>
          )}

          <Box className="w-full xl:w-2/3 flex flex-col gap-6">
            <Box
              className="flex-1 bg-gradient-to-br from-gray-50 to-white border border-gray-200/70 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden">
              <div className="w-full h-full p-4">
                <DimensionamentoMap
                  data={data}
                  state={state}
                  regionType={regionType}
                  statusFilter={statusFilter}
                  useGradient={useGradient}
                />
              </div>
            </Box>

            <Box className="flex justify-center items-center">
              <Box
                className="bg-white rounded-2xl border border-gray-200 shadow-lg px-6 py-4 hover:shadow-xl transition-all duration-300">
                <FormControlLabel
                  control={
                    <Switch
                      checked={useGradient}
                      color="success"
                      onChange={(e) => setUseGradient(e.target.checked)}
                      sx={{
                        '& .MuiSwitch-track': {
                          borderRadius: 26 / 2,
                        },
                        '& .MuiSwitch-thumb': {
                          boxShadow: '0 4px 8px 0 rgba(0,0,0,0.2)',
                        },
                      }}
                    />
                  }
                  label={
                    <span className="text-gray-700 font-semibold flex items-center gap-2">
                      Usar Gradiente
                    </span>
                  }
                  className="m-0"
                />
              </Box>
            </Box>
          </Box>
        </div>
      </div>
    </div>
  );
};

export default MapModal;